(() => {
  'use strict';
  const root = document.querySelector('.og26');
  const api = window.OG26CartAPI;
  if (!root || !api) return;
  const escape = value => String(value ?? '').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const storeRoot = window.Shopify?.routes?.root || '/';
  const dialog = document.createElement('dialog');
  dialog.className = 'og-cart-dialog';
  dialog.id = 'real-cart-dialog';
  dialog.setAttribute('aria-labelledby','real-cart-title');
  dialog.innerHTML = `<header><h2 id="real-cart-title">ショッピングカート</h2><button type="button" data-cart-close aria-label="カートを閉じる">閉じる ×</button></header><div class="og-cart-body"><p data-cart-status role="status" aria-live="polite"></p><div data-cart-lines></div><div data-cart-total></div><div data-cart-checkout hidden><p>送料などを含む最終金額は、ご注文手続きでご確認ください。</p><a class="button" href="${storeRoot}checkout">ご注文手続きへ</a></div><button class="og-cart-reload" type="button" data-cart-reload>カートを再読み込み</button><a class="text-link" href="${storeRoot}cart">カートページで確認する ↗</a></div>`;
  root.append(dialog);
  let busy = false;
  let lineSnapshot = '';
  const status = dialog.querySelector('[data-cart-status]');
  function pendingQuantity(){
    return [...dialog.querySelectorAll('[data-cart-change]')].some(input=>input.value!==input.dataset.cartCurrent);
  }
  function updateCheckout(){
    const blocked=busy||pendingQuantity();
    const checkout=dialog.querySelector('[data-cart-checkout] a');
    checkout.setAttribute('aria-disabled',String(blocked));
    checkout.tabIndex=blocked?-1:0;
  }
  function lock(value, control) {
    if(value)status.style.minHeight=`${status.getBoundingClientRect().height}px`;
    busy = value;
    dialog.setAttribute('aria-busy',String(value));
    dialog.querySelectorAll('[data-cart-pending]').forEach(button=>button.removeAttribute('data-cart-pending'));
    if(value&&control)control.setAttribute('data-cart-pending','');
    dialog.querySelectorAll('[data-cart-change], [data-cart-remove], [data-cart-reload], [data-cart-quantity-submit]').forEach(b=>b.disabled=value);
    updateCheckout();
  }
  function render(cart) {
    const lines = cart.items || [];
    const scrollTop=dialog.scrollTop;
    const focused=document.activeElement;
    const focusKind=focused?.matches('[data-cart-change]')?'cartChange':focused?.matches('[data-cart-remove]')?'cartRemove':focused?.matches('[data-cart-quantity-submit]')?'submit':null;
    const focusKey=focusKind==='submit'?focused.closest('[data-cart-quantity-form]').querySelector('[data-cart-change]').dataset.cartChange:focusKind?focused.dataset[focusKind]:null;
    root.querySelectorAll('.cart-count').forEach(n=>{n.textContent=cart.item_count;n.hidden=!cart.item_count;});
    const snapshot=JSON.stringify(lines);
    if(snapshot!==lineSnapshot){
    dialog.querySelector('[data-cart-lines]').innerHTML = lines.length ? lines.map(item => {
      const image = item.featured_image?.url || item.image;
      const safeImage = image && /^(https:|\/\/|\/)/.test(image) ? image : '';
      const properties=Object.entries(item.properties||{}).filter(([k,v])=>v&&!k.startsWith('_')).map(([k,v])=>`<p class="cart-line-property">${escape(k)}：${escape(v)}</p>`).join('');
      return `<article class="og-cart-line">${safeImage?`<img src="${escape(safeImage)}" alt="${escape(item.product_title)}" width="72" height="90">`:''}<div><h3>${escape(item.product_title)}</h3><p>${escape(item.variant_title || '')}</p>${properties}<strong class="og-cart-line-price">${api.money(item.final_line_price,cart.currency)}</strong><div class="og-cart-line-actions"><form class="og-cart-qty-form" data-cart-quantity-form><label>数量 <input type="number" inputmode="numeric" min="1" max="99" required value="${item.quantity}" data-cart-current="${item.quantity}" data-cart-change="${escape(item.key)}" aria-label="${escape(item.title)}の数量"></label><button type="submit" data-cart-quantity-submit>更新</button></form><button type="button" data-cart-remove="${escape(item.key)}">削除</button></div></div></article>`;
    }).join('') : '<p class="og-cart-empty">カートにはまだ商品がありません。</p>';
    lineSnapshot=snapshot;
    if(focusKind){
      const input=[...dialog.querySelectorAll('[data-cart-change]')].find(node=>node.dataset.cartChange===focusKey);
      const next=focusKind==='cartChange'?input:focusKind==='submit'?input?.closest('form').querySelector('[data-cart-quantity-submit]'):[...dialog.querySelectorAll('[data-cart-remove]')].find(node=>node.dataset.cartRemove===focusKey);
      if(next)next.focus({preventScroll:true});
    }
    }
    const totalHTML = lines.length
      ? `<div class="og-cart-total"><span>商品合計（税込）</span><strong>${api.money(cart.total_price,cart.currency)}</strong></div>${cart.total_discount?`<p>割引合計 ${api.money(cart.total_discount,cart.currency)}</p>`:''}` : '';
    const total=dialog.querySelector('[data-cart-total]');
    if(total.innerHTML!==totalHTML)total.innerHTML=totalHTML;
    dialog.querySelector('[data-cart-checkout]').hidden = !lines.length;
    dialog.scrollTop=scrollTop;
    window.dispatchEvent(new CustomEvent('og26:cartchange',{detail:cart}));
  }
  async function refresh(control) {
    if(busy) return;
    lock(true,control); status.textContent='カートを読み込み中です…';
    try {render(await api.read());status.textContent=pendingQuantity()?'数量を変更したら「更新」を押してください。':'';return true;}
    catch(error){status.textContent=error.message;dialog.querySelector('[data-cart-checkout]').hidden=true;return false;}
    finally{lock(false);}
  }
  async function open(notice='') {
    if(!dialog.open){status.textContent='';status.style.removeProperty('min-height');dialog.showModal();}
    const loaded=await refresh();
    if(notice)status.textContent=notice+(loaded?'':' '+status.textContent);
  }
  document.addEventListener('click', event => {
    if(event.target.closest('[data-cart-checkout] a')&&(busy||pendingQuantity())){
      event.preventDefault();
      if(!busy)status.textContent='数量を変更したら「更新」を押してからお進みください。';
      return;
    }
    const trigger=event.target.closest('[data-open="bag-dialog"], [data-real-cart]');
    if(trigger){event.preventDefault();event.stopImmediatePropagation();open();}
  },true);
  dialog.addEventListener('click',event=>{
    event.stopPropagation();
    if(event.target.closest('[data-cart-close]'))dialog.close();
    const reload=event.target.closest('[data-cart-reload]');
    if(reload)refresh(reload);
    const remove=event.target.closest('[data-cart-remove]');
    if(remove)change(remove.dataset.cartRemove,0,remove);
    if(busy&&event.target.closest('a'))event.preventDefault();
    if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}
  });
  dialog.addEventListener('input',event=>{
    if(event.target.matches('[data-cart-change]')){
      updateCheckout();
      status.textContent=pendingQuantity()?'数量を変更したら「更新」を押してください。':'';
    }
  });
  dialog.addEventListener('submit',event=>{
    if(!event.target.matches('[data-cart-quantity-form]'))return;
    event.preventDefault();
    event.stopPropagation();
    const input=event.target.querySelector('[data-cart-change]');
    const qty=Math.max(1,Math.min(99,Math.floor(Number(input.value)||1)));
    if(qty===Number(input.dataset.cartCurrent)){status.textContent='';return;}
    change(input.dataset.cartChange,qty,event.target.querySelector('[data-cart-quantity-submit]'));
  });
  async function change(id,qty,control){
    if(busy)return;
    lock(true,control);status.textContent='カートを更新中です…';
    try{render(await api.change(id,qty));status.textContent='カートを更新しました。';}
    catch(error){status.textContent=error.message;try{render(await api.read());}catch(_){dialog.querySelector('[data-cart-checkout]').hidden=true;}}
    finally{lock(false);}
  }
  root.querySelectorAll('[data-open="bag-dialog"]').forEach(button=>{
    button.replaceChildren(document.createTextNode('カートを見る'));
    button.setAttribute('aria-label','実際のショッピングカートを見る');
  });
  async function add(id,quantity,properties={}){
    if(busy)throw new Error('カートを更新中です。少しお待ちください。');
    lock(true);
    try{return await api.add(id,quantity,properties);}finally{lock(false);}
  }
  window.OG26Cart={open,add,refresh};
})();

